import React from 'react';

import { angularizeWithProviders } from '../../../shared/providers';
import { RegistrationFormAccessWidget } from '../../components/RegistrationFormAccessWidget/RegistrationFormAccessWidget';
import { nutritionRegistrationService } from '../../services/nutritionRegistrationService';
import { scanIqRegistrationService } from '../../services/scanIqRegistrationService';
import { SolutionTypeFlags } from '../../../shared/constants/user-info/solutionType';

type NgzRegistrationFormAccessProps = {
  entityId: number;
  activeSolutionFlags: SolutionTypeFlags;
};

const NgzRegistrationFormAccess = ({
  entityId,
  activeSolutionFlags,
}: NgzRegistrationFormAccessProps) => {
  return (
    <>
      {activeSolutionFlags.SCAN_IQ && (
        <RegistrationFormAccessWidget
          id={entityId}
          getRegistrationLink={scanIqRegistrationService.getRegistrationLink}
          getRegistrationQrCode={scanIqRegistrationService.getRegistrationQrCode}
          qrCodeDescription="A QR code has already been generated and assigned to your entity"
        />
      )}
      {activeSolutionFlags.NUTRITION && (
        <RegistrationFormAccessWidget
          id={entityId}
          getRegistrationLink={nutritionRegistrationService.getRegistrationLink}
          getRegistrationQrCode={nutritionRegistrationService.getRegistrationQrCode}
          qrCodeDescription="A QR code has already been generated and assigned to your entity"
        />
      )}
    </>
  );
};

angularizeWithProviders(NgzRegistrationFormAccess, 'ngzRegistrationFormAccess', {
  entityId: '<',
  activeSolutionFlags: '<',
});

export { NgzRegistrationFormAccess };
